import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function tier4SeoBlock() {
  const widgetName = 'tier4SeoBlock';
  const widgetOpts = tier4SeoBlockOpts;
  const $widget = $(`#${widgetName}`);

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($($widget), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      showDescription: true,
      hasImages: false,
      lazyLoadImages: false,
      imageIsBackground: false,
      textOverImage: false,
      itemsPerPanel: 1,
      maxItemsVisible: 1,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createCustomseoWidget(data.items);
          resolve(true);
        } else {
          $widget.remove();
          resolve(false);
        }
      },
    });
  });

  function createCustomseoWidget(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];

    $seo.replaceWith(`
        <h1 class="seo-title">${Title}</h1>
        <div class="seo-description">${Description}</div>
          ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>`}
    `);
  }
}
